import { render, staticRenderFns } from "./RadioButtonsWrapper.vue?vue&type=template&id=db985224&scoped=true&"
import script from "./RadioButtonsWrapper.vue?vue&type=script&lang=js&"
export * from "./RadioButtonsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./RadioButtonsWrapper.vue?vue&type=style&index=0&id=db985224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db985224",
  null
  
)

export default component.exports